import { Value } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Value>;
export const SelectValue = (props: Props) => {
    return <Value data-testid="select-value" {...props} />;
};
